import { useState, useCallback, useMemo } from "react";
import BtnSpinner from "../../../components/btnSpinner";
import { downloadInvoice } from "../service";
import { theme } from "../../../theme";
import ModalTemplate from "../../../components/modal/modalTemplate";

const InvoiceButton = ({ label, color, loading, onClick }) => (
    <button
        type="button"
        className={`btn btn-${color} btn-lg w-100 btn-sm`}
        disabled={loading}
        onClick={onClick}
    >
        {loading ? (
            <BtnSpinner />
        ) : (
            <>
                <i className="material-icons">receipt_long</i>&nbsp;
                {label}
            </>
        )}
    </button>
);

const Invoices = ({ job_id, show, handleClose }) => {
    const [loading, setLoading] = useState(false);

    const handleDownload = useCallback(
        async (type) => {
            setLoading(true);
            try {
                await downloadInvoice(job_id, type);
            } finally {
                setLoading(false);
            }
        },
        [job_id]
    );

    const modalBody = useMemo(
        () => (
            <div className="ftm-request-notification-body text-center">
                <h4 className="mb-2">Choose Invoice Type</h4>
                <p className="r3 px-md-5 px-sm-1 text-dark">
                    Select the invoice you would like to download for this job.
                </p>

                <div className="container mt-4">
                    <div className="row g-3">
                        <div className="col-sm">
                            <InvoiceButton
                                label="Customer"
                                color={theme.main}
                                loading={loading}
                                onClick={() =>
                                    handleDownload(
                                        "FTM_TO_CUSTOMER_PAYMENT_FULL_INVOICE"
                                    )
                                }
                            />
                        </div>

                        <div className="col-sm">
                            <InvoiceButton
                                label="Tradesperson"
                                color={theme.main}
                                loading={loading}
                                onClick={() =>
                                    handleDownload(
                                        "INSTAFIX_TO_FTM_PAYMENT_FULL_INVOICE"
                                    )
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
        ),
        [loading, handleDownload]
    );

    return (
        <ModalTemplate
            show={show}
            closeFun={handleClose}
            size={null}
            centered
            title="Download Invoice"
            body={modalBody}
            footer={null}
        />
    );
};

export default Invoices;